import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import CopyrightFooter from "../Footer/Copyright";
import { useNavigate } from "react-router-dom";

import TopBar from "./Bar/TopBar";
import SideBar from "./Bar/SideBar";
import PaintConteiner from "./Navegation/PaintConteiner";
import Backdropcircle from "../Loading/Backdrop";
import { useAuth } from "../Auth/AuthProtecter";

const mdTheme = createTheme();

const OriginQAORIG = process.env.REACT_APP_URL_QA;
const UrlPROD = process.env.REACT_APP_API_SINGIN_ADMIN_PROD;
const PORTVALID = process.env.REACT_APP_PORTVALID;

function DashboardContent() {
  const auth = useAuth();
  //
  const [Url, setLoginUrl] = React.useState("");
  const location = window.location;

  window.setTimeout(() => {
    if (location.port === PORTVALID || location.origin === OriginQAORIG) {
      setLoginUrl(OriginQAORIG);
    } else {
      setLoginUrl(UrlPROD);
    }
  }, 1);
  //
  const { firstname, lastname } = auth.infoUserDasboard.person;


  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [id, setId] = React.useState(1);
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const toggleChange = (newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    //
    if (!auth.isAuthenticated) {
      navigate("/signin", { replace: true });
    }

    //
  });

  return auth.isAuthenticated ? (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        {/*Barra*/}
        <TopBar
          open={open}
          firstname={firstname}
          lastname={lastname}
          toggleDrawer={toggleDrawer}
        />

        {/*left-Barra*/}
        <SideBar
          open={open}
          toggleDrawer={toggleDrawer}
          toggleChange={toggleChange}
        />
        {/*Main*/}
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          {" "}
          {/*Contenedor vacio*/}
          <Toolbar />
          {/*Contenedor view*/}
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <PaintConteiner value={value} id={id} />

            {/* informacion Copy */}
            {/* <CopyrightFooter sx={{ mt: 5 }} /> */}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  ) : (
    <>
      <Backdropcircle />
    </>
  );
}

export default function Dashboard() {
  return <DashboardContent />;
}
